var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1),_c('div',{class:'baseUseBox '+_vm.$store.getters.get_use},[_c('div',{staticClass:"wrap"},[_c('baseUse')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }